// ======================================================================
// File Name       : ContentDocumentRegisterContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Col, Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import ContentDocumentEditRegister from '../../components/content/ContentDocumentEditRegister';
import ContentDocumentConfirmDialog from '../../components/content/ContentDocumentConfirmDialog';
import DialogConfirm from '../../components/DialogConfirm';
import * as ContentDocumentAction from '../../actions/content/ContentDocumentAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { DATA_AFFIILIATION_TYPE_STR, DOCUMENT_EDIT_TYPE } from '../../constants/ContentConstant';
import { VALIDATE_TYPE, RETURN_MAX_NUM } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class ContentDocumentRegisterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registerSuccess: false,
      formValid: true,
      documentContentRegisterInfo: {
        contentSecernId: '',
        contentName: '',
        documentUpdateStatus: '',
        imageUrl: '',
        documentName: '',
        createdAt: '',
        updatedAt: '',
        noRecordFound: false,
      },
      showDialogConfirm: false,
      isEdit: false,
    };
    this.sendRegisterRequest = this.sendRegisterRequest.bind(this);
    this.handleOkClick = this.handleOkClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
  }

  sendRegisterRequest() {
    this.setState({ showDialogConfirm: false });
    const { valid, documentRegisterForm } = this.props;
    if (documentRegisterForm && documentRegisterForm.values && valid) {
      const params = {};
      params.editType = DOCUMENT_EDIT_TYPE.REGISTER;
      const documentDetail = {};
      documentDetail.contentSecernId = documentRegisterForm.values.contentSecernId || null;
      documentDetail.contentName = documentRegisterForm.values.contentName;
      params.documentContentInfo = documentDetail;
      if (documentRegisterForm.values.uploadFile) {
        params.uploadFile = documentRegisterForm.values.uploadFile[0];
      }
      this.props.dispatch(showLoading());
      this.props.dispatch(ContentDocumentAction.registerDocument(params));
    }
  }

  handleCancelClick() {
    this.setState({ showDialogConfirm: false });
  }

  handleOkClick() {
    if (this.props.valid) {
      this.setState({ showDialogConfirm: true });
    }
  }
  render() {
    const { documentContentRegisterInfo, registerSuccess, valid } = this.props;
    if (registerSuccess) {
      return <Redirect to={Path.CONTENT_DOCUMENT_LIST} />;
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DOCUMENT_LIST}
          text="ドキュメント一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ドキュメントの追加" />
        
        <ContentDocumentEditRegister
          {...documentContentRegisterInfo}
          isEdit={false}
        />
        <Col sm={12} className="text-center margin-top-20">
          <Button
            variant="primary"
            className="btn-96 margin-10"
            onClick={this.props.handleSubmit(this.handleOkClick)}
          >
            OK
          </Button>
        </Col>
        <ContentDocumentConfirmDialog
          showModal={this.state.showDialogConfirm}
          handleOkClick={this.props.handleSubmit(this.sendRegisterRequest)}
          handleCancelClick={this.handleCancelClick}
          documentData={documentContentRegisterInfo}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { registerSuccess } = state.document;
  let { documentContentRegisterInfo } = state.document;
  const { documentRegisterForm } = state.form;
  let documentContentDetail = { ...documentContentRegisterInfo };
  if (documentRegisterForm && documentRegisterForm.values) {
    documentContentDetail = { ...documentRegisterForm.values };
    if (documentRegisterForm.values.uploadFile && documentRegisterForm.values.uploadFile.length) {
      documentContentDetail.documentName = documentRegisterForm.values.uploadFile[0].name;
      documentContentDetail.documentSize = documentRegisterForm.values.uploadFile[0].size;
    }
  }
  documentContentRegisterInfo = documentContentDetail;
  return {
    ...{ documentContentRegisterInfo },
    ...{ documentRegisterForm },
    registerSuccess,
    initialValues: documentContentRegisterInfo,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'documentRegisterForm',
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: true,
})(ContentDocumentRegisterContainer));
